import { date, object, string } from 'yup';

export const BackgroundTaskStatus = {
  PENDING: 'PENDING',
  CANCELLED: 'CANCELLED',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  REVIEWED: 'REVIEWED',
  DISMISSED: 'DISMISSED',
};

const backgroundTaskSchema = object({
  id: string(),
  created_on: date(),
  updated_on: date(),
  type: string().oneOf(['AI_PROCESS']).required(),
  item_id: string(),
  user_id: string().required(),
  company_id: string().required(),
  status: string().oneOf(Object.keys(BackgroundTaskStatus)).required(),
});

export default backgroundTaskSchema;
